export const UPDATE_SELECT_ORGANIZATION_DETAILS = 'UPDATE_SELECT_ORGANIZATION_DETAILS';

export interface UpdateSelectOrganizationDetails {
  type: typeof UPDATE_SELECT_ORGANIZATION_DETAILS;
  payload: any;
}

export type OranizationTypes = UpdateSelectOrganizationDetails;
